import { useEffect, useState } from "react";
import Modal from "./Modal";
import axios from "axios";
import FlexBox from "./FlexBox";
import Button from "./Button";
import theme from "../styles/theme";
import MinimalSelect from "./MinimalSelect";
import { Icon } from "@mui/material";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  onSelect: (program: string) => void;
  fetchParent: (university: string, program: string) => void;
}

const Title = styled("div")`
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2633d4;
`;

export const UniProgSelect = ({
  isOpen,
  setOpen,
  onSelect,
  fetchParent,
}: Props) => {
  const [universityOption, setUniversityOption] = useState<any[]>([]);
  const [selectedUni, setSelectedUni] = useState<string>("");
  const [programOptions, setProgramOptions] = useState<any[]>([]);
  const [selectedProgram, setSelectedProgram] = useState<string>("");
  const [selectedProgId, setSelectedProgId] = useState<string>("");

  useEffect(() => {
    axios
      .get("/university")
      .then((res) => {
        const list = res.data.universities.map((v: any) => ({
          label: v.name,
          value: v.short_name,
        }));
        setUniversityOption(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedUni) return;

    axios
      .get(`/university?university_code=${selectedUni}`)
      .then((res) => {
        const list = res.data.universities[0].program.map((p: any) => ({
          label: p.short_name,
          value: p.short_name,
          id: p.id
        }));
        setProgramOptions(list);
      })
      .catch(() => {});
  }, [selectedUni]);

  useEffect(() => {
    const storedProgram = localStorage.getItem("selectedProgram");
    if (storedProgram) {
      setSelectedProgram(storedProgram);
      setOpen(false);
      onSelect(storedProgram);
    }
  }, []);

  const handleSelect = () => {
    localStorage.setItem("selectedProgram", selectedProgram);
    localStorage.setItem("selectedProgId",selectedProgId)
    localStorage.setItem("university", selectedUni);
    localStorage.removeItem("searchUniversity");
    localStorage.removeItem("searchKeyword");
    localStorage.removeItem("searchProgram");

    fetchParent(selectedUni, selectedProgram);
    onSelect(selectedProgram);
    setOpen(false);
    window.location.pathname = "/curriculum/version";
  };

  const CustomBox = styled("div")`
    margin-bottom: 16px;
    background: white;
    padding: 30px;
    border-radius: 5px;
    box-shadow: 0 0 10px ${theme.color.lightBlueGray300};
    width: 600px;
  `;

  return (
    <CustomBox>
      <Title>
        <Icon>account_balance</Icon>
        Select University & Program
      </Title>

      <div style={{ paddingTop: 20, fontSize: 14, color: "#575757" }}>
        University:
      </div>
      <MinimalSelect
        isClearable={false}
        onChange={(item: any) => {
          setSelectedUni(item.value);
          setSelectedProgram("");
        }}
        name="university"
        options={universityOption}
        styles={{
          container: (base) => ({ ...base, minWidth: "100%" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        value={universityOption.find((u: any) => u.value === selectedUni)}
      />

      <div style={{ paddingTop: 10, fontSize: 14, color: "#575757" }}>
        Program:
      </div>

      <MinimalSelect
        isClearable={false}
        onChange={(item: any) => {setSelectedProgram(item.value)
          setSelectedProgId(item.id)
        }}
        name="program"
        options={programOptions}
        isDisabled={!selectedUni}
        styles={{
          container: (base) => ({ ...base, minWidth: "100%" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        value={programOptions.find((p: any) => p.value === selectedProgram)}
      />

      <FlexBox justify="end" style={{ paddingTop: 30 }}>
        <Button
          className="reduce_opct_onhover"
          onClick={handleSelect}
          disabled={!selectedProgram}
          style={{
            width: 120,
            whiteSpace: "nowrap",
            background: theme.color.blueButton,
            color: "white",
            boxShadow: "0 2px 5px #808080cc",
            border: "none",
            gap: 10,
          }}
        >
          Start
          <Icon fontSize="small">start</Icon>
        </Button>
      </FlexBox>
    </CustomBox>
  );
};
